import ModuleManager from "../module_manager";
import GameUtil from "../../../utility/game_util";
import EventManager from "../../../manager/event_manager";
import UserDataManager, { IUserCurrencyData } from "../../../manager/user_manager";
import ModelData, { IUserData } from "../../../pacakge/public/model_data";
import AudioManager from "../../../manager/audio_manager";
import NetPrompt from "../../../pacakge/public/module/netprompt/netprompt";
import PromiseUtility from "../../../utility/promiseUtility";
import { resLoader } from "../../res/ResLoader";

const { ccclass, property } = cc._decorator;

@ccclass
export default class MVVMBase extends cc.Component {

    protected isDestroyed = false

    //隐藏模块，会同样停止http的返回事件
    protected isHide: boolean

    public _moduleShowId = 0

    public isInited: boolean

    private m_maxId = 0

    private m_callbackMap
    private mEventCallback: object
    protected onSelfCurrencyDataUpdate: (currencyData: IUserCurrencyData) => void
    protected onUserDataUpdate: (data: IUserData) => void

    private _resMap: string[];
    private _spriteMap: cc.SpriteFrame[];

    get nodeIsActive(): boolean {
        if (this.isInited && this.node != null && cc.isValid(this.node, true)) {
            return this.node.active;
        }
        return false;
    }

    get nodeIsValid(): boolean {
        if (this.node != null && cc.isValid(this.node, true)) {
            return true;
        }
        return false;
    }

    setActive() {
        if (this.node != null && cc.isValid(this.node, true)) {
            this.node.active = true
        }
    }

    //是否正常显示
    get normalShow(): boolean {
        return !this.isDestroyed && !this.isHide
    }

    // apiHttpGet(requestData: IHttpRequestData, responeSuccessCallback: (data : IHttpApiResponeData) => void, requestErrorCallback ?: (error : IHttpErrorData) => void) {

    // }


    //需要注意网络是有延时的，如果界面隐藏了需要是否过滤掉处理
    apiHttpGet(requestData: IHttpRequestData, responeSuccessCallback: (data: IHttpApiResponeData) => void, requestErrorCallback?: (error: IHttpErrorData) => void) {
        let self = this
        let _httpGetId = this._moduleShowId
        let _responeSuccessCallback = responeSuccessCallback
        let _responeErrorCallback = requestErrorCallback ? (error: IHttpErrorData) => {
            if (requestData.showNetPrompt) {
                let module: NetPrompt = ModuleManager.instance.getModule("NetPrompt");
                if (module) {
                    module.hideWithShowId(netPromptShowId)
                }
            }
            if (self.normalShow) {
                requestErrorCallback(error)
            }
        } : null
        let netPromptShowId = 0
        if (requestData.showNetPrompt) {
            let module = ModuleManager.instance.showModuleName("NetPrompt");
            netPromptShowId = module.showId
        }
        GameUtil.apiHttpGet(requestData, (data: IHttpApiResponeData) => {
            if (requestData.showNetPrompt) {
                let module: NetPrompt = ModuleManager.instance.getModule("NetPrompt");
                if (module) {
                    module.hideWithShowId(netPromptShowId)
                }
            }
            if (self.normalShow && _httpGetId == self._moduleShowId) {
                if (data.code == "SUCCESS") {
                    _responeSuccessCallback(data)
                } else if (_responeErrorCallback) {
                    _responeErrorCallback(data)
                }
            }
        }, _responeErrorCallback)
    }

    http_get_all(requestList: IUrlRequestAllData[], onAllFinish: (data: IUrlResponseAllData) => void) {
        let self = this
        let funList = []
        let responseAllData: IUrlResponseAllData = {
            responseDataMap: {},
            errDataList: [],
        }

        for (let index = 0; index < requestList.length; index++) {
            const request = requestList[index];
            let tmpFun = function (cb) {
                self.apiHttpGet(request.requestData, (data) => {
                    responseAllData.responseDataMap[request.requestData.baseUrl] = {
                        successData: data,
                    }
                    request.responeErrorCallback && request.responeErrorCallback(data)
                    cb && cb()
                }, function (error: IHttpErrorData) {
                    responseAllData.responseDataMap[request.requestData.baseUrl] = {
                        errData: error,
                    }
                    responseAllData.errDataList.push({ url: request.requestData.baseUrl, errData: error })
                    request.responeErrorCallback && request.responeErrorCallback(error)
                    cb && cb()
                })
            }
            funList.push(tmpFun)
        }
        let _httpGetId = this._moduleShowId
        PromiseUtility.all(funList).then(function () {
            if (_httpGetId != self._moduleShowId) {
                return
            }
            onAllFinish && onAllFinish(responseAllData)
        })
    }

    /**
     * 获取其他用户信息
     */
    getUserData(uid: Number, callback: (data: IUserData) => void, useNewData?: boolean) {
        let self = this;
        UserDataManager.getData(uid, (data: IUserData) => {
            if (self.normalShow && callback) {
                callback(data);
            }
        }, useNewData);
    }

    /**
     * 获取自己的数据
     */
    getSelfUserData(callback?: (data: IUserData) => void, useNewData?: boolean) {
        let self = this
        ModelData.instance.roleData.id && self.getUserData(ModelData.instance.roleData.id, callback, useNewData)
    }

    /**
     * 获取自己的货币数据
     */
    getSelfCurrencyData(callback?: (currencyData: IUserCurrencyData) => void, useNewData?: boolean, immediatelyObtail?: boolean) {
        let self = this;
        ModelData.instance.roleData.id && UserDataManager.getCurrencyData(ModelData.instance.roleData.id, (currencyData: IUserCurrencyData) => {
            if (self.normalShow && callback) {
                callback(currencyData);
            }
        }, useNewData, immediatelyObtail);
    }

    /**
     * 加载动态资源
     * @param url 
     * @param completeCallback 
     * @param type 
     * @param connect 
     */
    loadRes(url: string, completeCallback: (error: Error, resource: any) => void, type?: typeof cc.Asset, connect?: number) {
        let self = this;
        GameUtil.loadRes(url, (error, resource) => {
            if (resource) {
                if (self._resMap == null) {
                    self._resMap = []
                }
                self._resMap.push(url)
            }
            if (!self.isDestroyed && !error && completeCallback) {
                completeCallback(error, resource);
            }

        }, type, connect);
    };

    //加载本地图片
    loadSprite(sprite : cc.Sprite, url : string, completeCallback: (error: Error, resource: any) => void) {
        let self = this
        GameUtil.loadRes(url, (error, spriteFrame) => {
            if (spriteFrame) {
                if (self._spriteMap == null) {
                    self._spriteMap = []
                }
                self._spriteMap.push(spriteFrame)
                // resLoader.addUse(resConf.url, resConf.use)
                // let url = resLoader.getUrlByAsset(srcAsset);
                // if(resLoader.addUse(url, url)) {
               
                // }
            }
            completeCallback && completeCallback(error, spriteFrame)
        }, cc.SpriteFrame)
    }

    releaseRes(node: cc.Node, url: string, use?: string) {

        node.destroy();
        GameUtil.releaseRes(url, use)

    }

    /**
     * 播放音效
     * @param url 
     * @param loop 
     * @param onFinish 
     */
    playSound(url: string, loop: boolean = false, onFinish?: Function,onStart?: Function) {

        let self = this;
        //AudioManager.instance.playSound(url, loop, onFinish,onStart);

        AudioManager.instance.playSound(url, loop, () => {
            if (self.normalShow) {
                if (onFinish) {
                    onFinish();
                }
            }
        },onStart);
    }

    stopSound(id : number){
                
        AudioManager.instance.stopSound(id);
    }


    //真实时间的调用，就算界面被隐藏也将继续
    doSchedule(callback: Function, interval?: number, repeat?: number, delay?: number) {
        this.m_callbackMap = this.m_callbackMap ? this.m_callbackMap : {}
        let self = this
        let id = ++this.m_maxId
        let tmpFun = function () {
            if (!repeat) {
                self.cancelSchedule(id)
            }
            callback()
        }
        this.m_callbackMap[Number(id)] = tmpFun
        this.schedule(tmpFun, interval, repeat, delay)
        return id
    }

    //真实时间的调用，就算界面被隐藏也将继续
    doScheduleOnce(callback: Function, delay: number) {
        this.m_callbackMap = this.m_callbackMap ? this.m_callbackMap : {}
        let id = ++this.m_maxId
        let tmpFun = function () {
            this.m_callbackMap[id.toString()] = null
            callback()
        }
        this.m_callbackMap[Number(id)] = tmpFun
        this.scheduleOnce(tmpFun, delay)
        return id
    }


    cancelSchedule(id: number) {
        if (this.m_callbackMap) {
            let key = id.toString()
            let callback = this.m_callbackMap[key]
            if (callback) {
                this.unschedule(callback)
                this.m_callbackMap[key] = null
            }
        }

    }

    cancelAllSchedule() {
        for (const key in this.m_callbackMap) {
            if (this.m_callbackMap.hasOwnProperty(key)) {
                const callback = this.m_callbackMap[key];
                if (callback) {
                    this.unschedule(callback);
                    this.m_callbackMap[key] = null;
                }
            }
        }

        delete this.m_callbackMap;
    }

    eventDispatch(eventName: string, ...data) {
        return EventManager.instance.dispatch(eventName, ...data)
    }

    eventBind(eventName: string, callback: Function) {
        this.mEventCallback = this.mEventCallback ? this.mEventCallback : {}
        this.mEventCallback[eventName] = callback
        EventManager.instance.on(eventName, callback, this, true)
    }

    //新增了绑定事件，只会触发调用一次就会自动回收
    eventBindOnce(eventName: string, callback: Function) {
        this.mEventCallback = this.mEventCallback ? this.mEventCallback : {}
        this.mEventCallback[eventName] = callback
        EventManager.instance.on(eventName, callback, this, true, true)
    }

    eventUnBind(eventName: string, callback: Function) {
        this.mEventCallback = this.mEventCallback ? this.mEventCallback : {}
        this.mEventCallback[eventName] = null
        EventManager.instance.off(eventName, callback, this)
    }

    protected _baseDestroy(releaseResources) {
        for (const key in this.mEventCallback) {
            if (this.mEventCallback.hasOwnProperty(key)) {
                const callback = this.mEventCallback[key];
                EventManager.instance.off(key, callback, this)
            }
        }
        if (releaseResources) {
            if (this._spriteMap) {
                this._spriteMap.forEach((value) => {
                    // let texture = value.spriteFrame.getTexture()
                    // value.spriteFrame.clearTexture()
                    // // texture.destroy()
                    // value.spriteFrame = null
                    resLoader.releaseRes(resLoader.getUrlByAsset(value))
                })
            } 
            this._resMap && resLoader.releaseArray(this._resMap)
        }
    }

}